import type React from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'styled-bootstrap-grid';

import { Field } from '@/js/libs/final-form';
import { Button, FormGroup, Icons, InnerCol } from '@/js/libs/ui';

import TextField from 'src/components/form/fields/TextField';

// TODO: Refactor
export const StatusFields: React.FC<{ field: string }> = ({ field }) => {
  const [t] = useTranslation(['backend', 'common', 'serviceDashboard']);
  const { fields } = useFieldArray(field);
  return (
    <>
      <Row>
        <Col md={12}>
          <p>
            <b>{t('common:CONTACT_STATUS')}</b>
          </p>
        </Col>
      </Row>
      {fields.map((fieldName, index) => (
        <FormGroup key={`status_${index}`}>
          <InnerCol md={6} data-testid='contact-status-field'>
            <Field<string> name={fieldName} render={(props) => <TextField {...props} />} />
          </InnerCol>
          <Col md={6}>
            <Button data-testid='delete-item-button' onClick={() => fields.remove(index)} icon variant='delete' square>
              <Icons.Trash alt />
            </Button>
          </Col>
        </FormGroup>
      ))}
      <Row>
        <Col>
          <Button onClick={() => fields.push('')} square data-testid='add-status-button'>
            <Icons.Plus alt />
          </Button>
        </Col>
      </Row>
    </>
  );
};
